import {useEffect} from 'react';
import {useNative} from 'app/contexts/NativeContext';

export default function useNativeReloadSoftticker(softTickerOpen) {
  const {isFlutter} = useNative();
  useEffect(() => {
    if (!isFlutter) {
      return;
    }

    if (softTickerOpen) {
      window.handleNativeResume = () => {};
    } else {
      window.handleNativeResume = () => {
        window.location.reload();
      };
    }
    return () => {
      window.handleNativeResume = () => {};
    };
  }, [softTickerOpen]);
}
